import { render, staticRenderFns } from "./TerminosCondiciones.vue?vue&type=template&id=3aa92aff&scoped=true&"
import script from "./TerminosCondiciones.vue?vue&type=script&lang=ts&"
export * from "./TerminosCondiciones.vue?vue&type=script&lang=ts&"
import style0 from "./TerminosCondiciones.vue?vue&type=style&index=0&id=3aa92aff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa92aff",
  null
  
)

export default component.exports